
import styles from "./NotesPage.module.scss";
import { Button, Layout } from "components";
import { useEffect, useState } from "react";
import Body from "./components/Body";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { getNotesData } from "service/NotesService";

const NotesPage = () => {
  const [render,setRender] = useState(false)
  const [query, setQuery] = useState("");
  const [searchNotes, setSearchNotes] = useState([]);
  const [notes, setNotes] = useState([]);
  const getData = async () => {
    try {
      let response = await getNotesData(notes);
      setNotes(response.data)
   
    } catch (error) {
      console.log("CHU")
    }
  };
  useEffect(() => {
    getData();
    setRender(false)
   
  }, [render]);

  const notesAll = (searchNotes || notes).filter((note) => !note.archived);
  const notesArchive = (searchNotes || notes).filter((note) => note.archived);

  useEffect(() => {
    setSearchNotes(
    
      notes.filter((note) =>
        note.body.toLowerCase().includes(query.toLowerCase())
      )
    );
  }, [query, notes]);

  return (
    <Layout>
     <div className={styles["note-app"]}>
      <Header search={query} setQuery={setQuery} setNotes={setNotes} />
      <Body
        notesAll={notesAll}
        notesArchive={notesArchive}
        setNotes={setNotes}
      />
      <Footer />
    </div>
    </Layout>
  );
};

export default NotesPage;
